import React from "react";
import { IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { ChatAvatar } from "./ChatAvatar";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { combineProps } from "../../../../helpers/objectHelper";
import { PeopleListPopover } from "./PeopleList";
import { ConversationListPopover } from "./ConversationList";
import GroupIcon from "@material-ui/icons/Group";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import CloseIcon from "@material-ui/icons/Close";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { PersonInformationPopover } from "./shared/PersonInformationPopover";
import { UndreadMessageSnackbar } from "./UnreadMessageSnackbar";

export function PersonDetails(props) {
  const { currentChat, orderList = [], chatTemplate, chats, missedGroupMessages, clientKey, settings, exhibitor = false, deselectChat = () => null, interactionAllowOneToOneChat } = props;

  const { showSnackbar } = settings;

  const snackbarPosition = { vertical: settings?.vertical || "bottom", horizontal: settings.horizontal || "left" };
  const { header, primaryColor } = chatTemplate;
  const person = orderList.find((o) => o.badgeNo == currentChat);
  const undreadMessages = () => {
    let count = 0;
    chats.map((c) => {
      if (c.seen == false && c.target != currentChat) {
        count += c.messages.filter((m) => m.seen == false && m.receiver == clientKey).length;
      }
      if (c.target == "ALL" && c.seen == false && currentChat != "ALL") {
        count += missedGroupMessages;
      }
    });
    return count;
  };
  return (
    <>
      {showSnackbar == true ? <UndreadMessageSnackbar undreadMessages={undreadMessages()} position={snackbarPosition} /> : false}
      <List style={{ padding: 0 }}>
        <ListItem>
          <ListItemAvatar>
            <PersonInformationPopover
              {...combineProps([
                props,
                {
                  target: person ? person.badgeNo : null,
                  show: !exhibitor,
                },
              ])}
            >
              <ChatAvatar {...combineProps([props, chatTemplate, { target: person ? person.badgeNo : null }])}>
                <ChatIcon person={person} {...props} />
              </ChatAvatar>
            </PersonInformationPopover>
          </ListItemAvatar>
          <TargetName person={person} {...combineProps([props, header])} />
          {!exhibitor ? (
            <ListItemSecondaryAction style={{ display: "flex" }}>
              <ConversationListPopover badgeValue={undreadMessages()} {...props} />
              {interactionAllowOneToOneChat ? <PeopleListPopover {...props} /> : null}
            </ListItemSecondaryAction>
          ) : (
            <ListItemSecondaryAction style={{ display: "flex" }}>
              <IconButton onClick={deselectChat}>
                <CloseIcon />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </ListItem>
      </List>
    </>
  );
}

const TargetName = ({ currentChat, fontWeight, fontFamily, color, fontSize, person, preview }) => {
  const textStyle = {
    fontWeight,
    fontFamily,
    fontSize,
    color,
    width: "50%",
  };

  if (preview) {
    return (
      <ListItemText
        primary={
          <span className="ellipsis" style={{ ...textStyle, lineHeight: "normal" }}>
            Kent Kentsson
          </span>
        }
        secondary={
          <span
            className="ellipsis"
            style={{
              ...textStyle,
              lineHeight: "normal",
              fontWeight: "normal",
              fontSize: textStyle.fontSize,
            }}
          >
            Bolag AB
          </span>
        }
      />
    );
  }
  if (currentChat == `ALL`) {
    return (
      <ListItemText
        primary={
          <span className="ellipsis" style={textStyle}>
            <EventLabel2 name="OpenChat" groupName="DigitalMeeting.Chat" />
          </span>
        }
        secondary={null}
      />
    );
  }
  if (currentChat == `MODERATOR`) {
    return (
      <ListItemText
        primary={
          <span className="ellipsis" style={textStyle}>
            <SystemLabel name="Moderator" />
          </span>
        }
        secondary={
          <span className="ellipsis" style={{ ...textStyle, fontWeight: "normal" }}>
            <SystemLabel name="AskYourQuestions" />
          </span>
        }
      />
    );
  } else if (person) {
    return (
      <ListItemText
        primary={
          <span className="ellipsis" style={{ ...textStyle, lineHeight: "normal" }}>
            {person.name}
          </span>
        }
        secondary={
          <span
            className="ellipsis"
            style={{
              ...textStyle,
              lineHeight: "normal",
              fontWeight: "normal",
              fontSize: textStyle.fontSize,
            }}
          >
            {person.company}
          </span>
        }
      />
    );
  } else return null;
};

const ChatIcon = ({ currentChat, person }) => {
  if (currentChat == `ALL`) return <GroupIcon />;
  else if (currentChat == `MODERATOR`) return <VerifiedUserIcon />;
  else if (person) return person.nameInitials;
  return null;
};
